import { useEffect, useRef } from 'react';
import ApiService from "../shared/utils/ApiService";

export const useApi = () => {
	const requestsRef = useRef(new Map());

	const generateKey = () => {
		return `${ Date.now() }_${ Math.random().toString(36).substring(2) }`;
	};

	const request = async (url, options = {}) => {
		const key = generateKey();
		requestsRef.current.set(key, true);

		try {
			const result = await ApiService.request(url, options, key);
			requestsRef.current.delete(key);
			return result;
		} catch (error) {
			requestsRef.current.delete(key);
			throw error;
		}
	};

	const get = async (url, options = {}) => {
		const key = generateKey();
		requestsRef.current.set(key, true);

		try {
			const result = await ApiService.get(url, options, key);
			requestsRef.current.delete(key);
			return result;
		} catch (error) {
			requestsRef.current.delete(key);
			throw error;
		}
	};

	const post = async (url, data = {}, options = {}) => {
		const key = generateKey();
		requestsRef.current.set(key, true);

		try {
			const result = await ApiService.post(url, data, options, key);
			requestsRef.current.delete(key);
			return result;
		} catch (error) {
			requestsRef.current.delete(key);
			throw error;
		}
	};

	const del = async (url, options = {}) => {
		const key = generateKey();
		requestsRef.current.set(key, true);

		try {
			const result = await ApiService.delete(url, options, key);
			requestsRef.current.delete(key);
			return result;
		} catch (error) {
			requestsRef.current.delete(key);
			throw error;
		}
	};

	useEffect(() => {
		return () => {
			requestsRef.current.forEach((_, key) => {
				ApiService.abort(key);
			});
			requestsRef.current.clear();
		};
	}, []);

	return { request, get, post, del };
};